import { Currency } from '../types';

export const BaseCurrency = 'HUF' as Currency;
